export default "__VITE_ASSET__SFSXW60c__"